import $ from 'jquery';

// Module name
export const MODULE_NAME = 'playvideo';

export let global_vars = {};

export function initialize() {
    $('body').on('click', '.video-playIcon', function() {
        let videoContainer = $(this).closest('.video');
        let video = videoContainer.find('video');
        // play the video and show controls
        video
            .prop('controls', true)
            .get(0)
            .play();
        videoContainer.toggleClass('video--playing');
    });
}
